import { useTranslation } from 'react-i18next';

// Import components
import { PriceInfo } from 'components/views/offer_configurator/components/common';
import { MainPacketChannels } from './MainPacketChannels';
import { MainPacketButton } from './MainPacketButton';
import { CurrentMainButton } from './CurrentMainButton';
import { ChannelsButton } from './ChannelsButton';

// Import styles
import { CardContainer, HeaderContainer, PacketName, ChannelsInfo, Recommendation, PriceWrapper, ButtonsWrapper } from '../styles/packet';

// Import context
import { useMainPacketContext } from 'components/context/main_packet/MainPacketProvider';

// Import hooks
import { useChannelsModal } from '../hooks/useChannelsModal';

export const MainPacket = () => {
	const { t } = useTranslation('configurator');

	const openModal = useChannelsModal();

	const {
		packet: { context, title, channels },
		isCurrent,
		isCanceled,
		isAnyPromotion,
		calculatedPrice
	} = useMainPacketContext();

	const hideRecommended = isCurrent && !isCanceled;

	const isRecommended = Boolean(context.is_recommended) && !hideRecommended;

	return (
		<>
			<CardContainer isRecommended={isRecommended} isCurrent={isCurrent}>
				{isRecommended && <Recommendation>{t('offer_review_packets_main_recommended')}</Recommendation>}
				<HeaderContainer>
					<PacketName>{t('offer_packet_main_title', { title })}</PacketName>

					<ChannelsInfo onClick={openModal} disabled={!channels.length} isVisible>
						{t('channels_count', { count: channels.length })}
					</ChannelsInfo>
				</HeaderContainer>

				<MainPacketChannels channels={channels} openModal={openModal} />

				<PriceWrapper isAnyPromotion={isAnyPromotion}>
					<PriceInfo calculatedPrice={calculatedPrice} />
				</PriceWrapper>

				<ButtonsWrapper>
					{isCurrent ? <CurrentMainButton /> : <MainPacketButton />}

					<ChannelsButton openModal={openModal} />
				</ButtonsWrapper>
			</CardContainer>
		</>
	);
};
